module.exports = __webpack_public_path__ + "static/media/cartao-frente.f9f22abf.svg";